import {
  ArticleData,
  ArticleDataContext,
} from 'articleEditor/contexts/articleDataProvider';
import { LanguageContext } from 'lib-knowledge-management-common/contexts/language';
import { useContext } from 'react';

/**
 * Find the article title to display in modals Will default to default language
 * otherwise use the current language
 */
export function useArticleDisplayTitle(): () => string {
  const article = useContext(ArticleDataContext);
  const { selectedLanguage, defaultLanguage } = useContext(LanguageContext);

  return () =>
    getArticleDisplayTitle({
      article,
      selectedLanguageId: selectedLanguage.languageId,
      defaultLanguageId: defaultLanguage.languageId,
    });
}

export function getArticleDisplayTitle({
  article,
  selectedLanguageId,
  defaultLanguageId,
}: {
  article: ArticleData;
  selectedLanguageId: string;
  defaultLanguageId: string;
}): string {
  return (
    article.translations.draft.find((t) => t.languageId === defaultLanguageId)
      ?.title ||
    article.translations.draft.find((t) => t.languageId === selectedLanguageId)
      ?.title ||
    'Untitled'
  );
}
